var exports = {
  "Oh": "ScrollIndicatorOverlay.module__scrollIndicatorLayer___dUprUj",
  "U4": "ScrollIndicatorOverlay.module__indicatorSlot___dUprUj",
  "Hr": "ScrollIndicatorOverlay.module__indicatorSlotTop___dUprUj",
  "Jm": "ScrollIndicatorOverlay.module__indicatorSlotBottom___dUprUj",
  "q3": "ScrollIndicatorOverlay.module__indicator___dUprUj",
  "lL": "ScrollIndicatorOverlay.module__indicatorBrand___dUprUj",
  "Gi": "ScrollIndicatorOverlay.module__indicatorMention___dUprUj",
};

module.exports = exports;
